import React, { useEffect, useState } from "react";
import './css/admin.css';
import axios from 'axios';
import config from "../../config";
import Title from "./title";
import StatusList from "./StatusList";
import FilialList from "./FilialList";
import Settings from "./Settings";
import Banners from "./Banners"
import Contacts from "./Contacts";

const MyCargo = () => {
  const [company, setCompany] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);

  const loadCompany = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const { data } = await axios.get(`${config.apiUrl}/api/company/my-company`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setCompany(data.company);
    } catch (error) {
      console.error('Ошибка загрузки компании:', error);
    }
  };

  useEffect(() => {
    loadCompany();
  }, []);

  const getLogoUrl = () => {
    const logoValue = company?.logo;
    if (!logoValue) return null;
    return logoValue.startsWith('http') ? logoValue : `${config.apiUrl}${logoValue}`;
  };

  const handleLogoChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setLogoFile(event.target.files[0]);
    }
  };

  const handleUploadLogo = async () => {
    if (!logoFile) return;

    setUploadingLogo(true);

    const formData = new FormData();
    formData.append('logo', logoFile);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${config.apiUrl}/api/upload/company-logo`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      const newLogoUrl = response.data.logoUrl;
      setCompany(prev => ({ ...prev, logo: newLogoUrl }));
      setLogoFile(null);
      window.dispatchEvent(new CustomEvent('companyLogoUpdated', { detail: newLogoUrl }));
      alert('Логотип успешно загружен');
    } catch (error) {
      console.error('Ошибка загрузки логотипа:', error);
      alert(error.response?.data?.message || 'Ошибка загрузки логотипа');
    } finally {
      setUploadingLogo(false);
    }
  };

    return (
      
        <div className="my-cargo mainAdmin">
            <Title text="Мой карго"/>
            <div className="section-my-cargo">
                <div className="status-list">
                  <h1 className="status-list-title">Логотип компании</h1>
                  <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
                    {getLogoUrl() ? (
                      <img
                        src={getLogoUrl()}
                        alt="Логотип компании"
                        style={{ maxWidth: 200, maxHeight: 90, objectFit: 'contain', border: '1px solid #ccc', padding: 4 }}
                      />
                    ) : (
                      <span>Логотип не задан</span>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      <input type="file" accept="image/*" onChange={handleLogoChange} />
                      <button
                        className="filialAdd-button"
                        type="button"
                        onClick={handleUploadLogo}
                        disabled={!logoFile || uploadingLogo}
                      >
                        {uploadingLogo ? 'Загрузка...' : 'Загрузить логотип'}
                      </button>
                    </div>
                  </div>
                </div>
            </div>
            <div className="section-my-cargo">
                <Settings/>
                <div className="my-cargo-flex2">
                    <Contacts/>
                </div>
            </div>
            <div className="section-my-cargo">
                <Banners/>

            </div>
            <div className="section-my-cargo">
                <StatusList/>
                <FilialList/>

            </div>


        </div>

    )
}

export default MyCargo;